import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from './firebase'

export type NewsletterPlacement = 'article' | 'homepage_briefing' | 'footer'

export type NewsletterSignupInput = {
  email: string
  placement: NewsletterPlacement
  path: string
  website: string
  consent: true
  attribution: Record<string, string>
}

export type NewsletterSignupResult = {
  accepted: true
  nextStep: 'check-email'
  delivery: 'queued'
}

const subscribeCall = httpsCallable<NewsletterSignupInput, NewsletterSignupResult>(firebaseFunctions, 'subscribeNewsletter')
const availabilityCall = httpsCallable<void, { accepting: boolean }>(firebaseFunctions, 'getNewsletterAvailability')
let availabilityRequest: Promise<boolean> | undefined
let availabilityCheckedAt = 0

export function getNewsletterAvailability(refresh = false): Promise<boolean> {
  if (refresh || !availabilityRequest || Date.now() - availabilityCheckedAt > 60_000) {
    availabilityCheckedAt = Date.now()
    availabilityRequest = availabilityCall().then(({ data }) => data.accepting === true).catch((error: unknown) => {
      availabilityRequest = undefined
      throw error
    })
  }
  return availabilityRequest
}

export async function subscribeToNewsletter(input: NewsletterSignupInput): Promise<NewsletterSignupResult> {
  const result = await subscribeCall(input)
  return result.data
}
